import React from 'react';
import styled from 'styled-components';
import { parseISO, format } from 'date-fns/fp';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Card } from './Card';
import { CARD_VARIANT } from './constants';
import { getHeaderVariant } from './utils/responsiveProps';
import { CardInfo } from '../cardInfo/CardInfo';
import { Tag } from '../tag/Tag';
import { Link } from '../link/Link';

const articleCardAuthorStyle = variant({
  key: 'card.article.author',
});

const AuthorInfo = styled.div`
  ${articleCardAuthorStyle}
  display: flex;
  align-items: center;
  font-size: ${themeGet('card.article.author.fontSize')};
  font-weight: ${themeGet('card.article.author.fontWeight')};
`;

const Avatar = styled.div`
  display: inline-block;
  border-radius: 100%;
  margin-right: 8px;
  width: ${themeGet('card.article.avatar.size')};
  height: ${themeGet('card.article.avatar.size')};
  background-image: url("${props => props.imgUrl}");
  background-position: center center;
  background-size: cover;
`;

const articleCardDateStyle = variant({
  key: 'card.article.date',
});

const Date = styled.span`
  ${articleCardDateStyle}
  font-size: ${themeGet('card.article.date.fontSize')};
`;

const Head = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ArticleCard = ({
  variant,
  coverUrl,
  author,
  date,
  dateFormat,
  title,
  description,
  cardInfoData,
  tags,
  links,
  ...rest
}) => {
  const headerVariant = getHeaderVariant(variant, coverUrl);
  const header = (
    <Head>
      <AuthorInfo variant={headerVariant}>
        <Avatar imgUrl={author.imgUrl} />
        {author.name}
      </AuthorInfo>
      <Date variant={headerVariant}>{format(dateFormat, parseISO(date))}</Date>
    </Head>
  );

  return (
    <Card
      variant={variant}
      coverUrl={coverUrl}
      header={header}
      footer={cardInfoData && <CardInfo data={cardInfoData} />}
      {...rest}
    >
      <Card.Meta title={title} description={description}>
        {tags && <Tag.Group maxCounts={2}>{tags}</Tag.Group>}
        {links && <Link.Group maxCounts={2}>{links}</Link.Group>}
      </Card.Meta>
    </Card>
  );
};

ArticleCard.defaultProps = {
  variant: CARD_VARIANT.VERTICAL,
  author: {},
  dateFormat: 'yyyy-MM-dd',
};

ArticleCard.Meta = Card.Meta;
